import { useScroll } from "framer-motion";
import { useEffect, useRef } from "react";
import mixpanel from "@/utils/mixpanel";

const ScrollEventHelper = ({
  threshold = 50,
  handler,
  masterclass,
  landing_page,
}: {
  threshold?: number;
  handler?: Function;
  masterclass?: any;
  landing_page?: string;
}) => {
  const PIXEL_ID = process.env.NEXT_PUBLIC_FB_PIXEL_NEW_ID;
  const { scrollYProgress } = useScroll();
  const isTrackedRef = useRef(false);

  useEffect(() => {
    const unsubscribe = scrollYProgress.onChange((v) => {
      const scrollHeight = document.documentElement.scrollHeight;
      const innerHeight = window.innerHeight;
      const maxScroll = scrollHeight - innerHeight;
      const scrollRatio = threshold / 100;

      if (maxScroll > 0 && v >= scrollRatio && !isTrackedRef.current) {
        isTrackedRef.current = true;
        mixpanel.track(`${threshold}% Scroll`, {
          page_location: window.location.href,
          page_referrer: document.referrer,
          masterclass: masterclass?.title,
          landing_page: landing_page,
          masterclassId: masterclass?.id,
          platform: "astrolearn",
        });
        //@ts-ignore
        if (fbq) {
          //@ts-ignore
          fbq("trackSingleCustom", `${threshold}% Scroll`);
          console.log(`Fired ${threshold}% Scroll event`);
        }
        if (handler) {
          handler();
        }
      } else if (maxScroll <= 0) {
        console.log("Page not scrollable or calculation issue.");
      }
    });

    return () => {
      unsubscribe();
    };
  }, [scrollYProgress, threshold, PIXEL_ID, handler]);

  return null;
};

export default ScrollEventHelper;
